import { css } from '@emotion/css';
import { cssObj } from '@/css/resources/functions.css';
import { fluidValues, fontStyle } from '@/css/resources/mixins.css';

import { fontFamilies, transitions } from '@/css/resources/variables.css';

const getStyles = () =>
	css({
		display: 'flex',
		flexDirection: 'column',
		borderTop: '1px solid #000',
		borderBottom: '1px solid #000',
		padding: '10px 0',
		fontFamily: fontFamilies.secondary,

		summary: cssObj(
			fontStyle(
				{
					fontSize: [15, 16],
					fontWeights: 400,
					lineheight: [22, 22],
				},
				false
			),
			{
				position: 'relative',
				display: 'flex',
				alignItems: 'center',
				cursor: 'pointer',

				'&::before': cssObj(
					fluidValues('width', 38, 42),
					fluidValues('height', 38, 42),
					fluidValues('marginRight', 8, 16),
					{
						display: 'flex',
						content: "''",
						backgroundImage: `url('data:image/png;base64,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')`,
						backgroundRepeat: 'no-repeat',
						backgroundPosition: 'center center',
						backgroundSize: '100% 100%',
					}
				),

				strong: {
					fontWeight: 700,
					paddingRight: 5,
				},

				span: {
					paddingLeft: 5,
				},

				svg: cssObj(
					fluidValues('width', 16, 20),
					fluidValues('height', 16, 20),
					{
						display: 'block',
						position: 'absolute',
						top: '50%',
						right: 0,
						transform: 'translateY(-50%)',

						line: {
							transform: 'scaleY(1)',
							transition: `transform ${transitions.fast} ease-out`,
							transformOrigin: 'center',
						},
					}
				),
			}
		),

		'.supt-falcDescription__text': cssObj(
			fontStyle(
				{
					fontSize: [18, 24],
					fontWeights: 400,
					lineHeight: [23, 31],
				},
				false
			),
			fluidValues('marginTop', 12, 16),
			fluidValues('marginBottom', 12, 20)
		),

		'&[open]': {
			summary: {
				svg: {
					'line:last-child': {
						transform: 'scaleY(0)',
					},
				},
			},
		},
	});

// edit
const getEditGlobalStyles = () =>
	cssObj({
		'.wp-block[data-type="supt/falc-description"]': cssObj({
			'.supt-falcDescription__headline': {
				'.supt-falcDescription__title, .supt-falcDescription__subtitle':
					{
						margin: 0,
					},
			},
			'.supt-falcDescription__text': {
				marginBottom: 0,
			},
		}),
	});

export { getStyles, getEditGlobalStyles };
